<app-stepper [numberOfSteps]="4" [currentStepIndex]="2"></app-stepper>
<app-logo class="bg-dark"></app-logo>
<div class="img-container">
    <img *ngIf="provider" class="providerImage" [src]=provider.registrationSelectorImage>
</div>
<p class="validationText"> {{"registration_auth0_title" | locale }}</p>
<div class="login-options">
    <form [formGroup]="registrationFormGroup" class="form-group">
        <mat-label>{{"Email"}}</mat-label>
        <mat-form-field appearance="outline">
            <input matInput formControlName="email"
                placeholder="{{'login_email_placeholder' |locale }}">
        </mat-form-field>
        <mat-label class="input-label">{{"Contraseña"}}</mat-label>
        <mat-form-field appearance="outline">
            <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'">
            <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
                <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>
        <button mat-flat-button
            [disabled]="!registrationFormGroup.valid || continueDisabled"
            (click)="login()"
            color="primary">
            {{"signup_button" | locale}}
            <mat-icon svgIcon="east" class="east"></mat-icon>
        </button>
    </form>
</div>
